<div class="container mt-3 pt-2" style="max-width: 100% !important;">
    <div class="row">
        <div class="col-sm-12 text-center">
            <div #btnClass class="btn-group">
                <!--Create Group & Dept.-->
                <!-- <div class="button-class create-group">
                    <button type="button" class="btn btn-top" routerLink="/groups/create-group">Add Practices</button>
                </div> -->
                <!--Create Group & Dept. ends here!!-->
                
                <!--View Group & Dept.-->
                <!-- <div class="button-class view-group">
                    <button type="button" class="btn btn-top" routerLink="/groups/view-group">View Practices</button>
                </div> -->
                <!--View Group & Dept. ends here!!-->

                <!--Create Members & TM.-->
                <div class="button-class create-member">
                    <button type="button" class="btn btn-top" routerLink="/groups/create-member">Add Members</button>
                </div>
                <!--Create Members & TM ends here!!-->

                <!--View Members & TM-->
                <div class="button-class view-member">
                    <button type="button" class="btn btn-top" routerLink="/groups/view-member">View Members</button>
                </div>
                <!--View Members & TM ends here!!-->
            </div>
        </div>
    </div>
</div>
<div>



<router-outlet></router-outlet>